export const FAVORITE_KIND = {
  ITEM: 'item',
  DESIGNER: 'designer',
  BOUTIQUE: 'boutique',
  ARTIST: 'artist',
};

export const listingKindToFavoriteKind = (listingKind) => {
  if (listingKind === 'designer_item' || listingKind === 'designer') {
    return FAVORITE_KIND.DESIGNER;
  }
  if (listingKind === 'boutique_item' || listingKind === 'boutique') {
    return FAVORITE_KIND.BOUTIQUE;
  }
  if (listingKind === 'artist_item' || listingKind === 'artist') {
    return FAVORITE_KIND.ARTIST;
  }
  return FAVORITE_KIND.ITEM;
};

export const favoriteKindToScoresType = (favoriteKind) => {
  if (favoriteKind === FAVORITE_KIND.DESIGNER) return 'designer_item';
  if (favoriteKind === FAVORITE_KIND.BOUTIQUE) return 'boutique_item';
  if (favoriteKind === FAVORITE_KIND.ARTIST) return 'artist_item';
  return 'item';
};

export const favoriteKindToAnalyticsType = favoriteKindToScoresType;

export const buildFavoriteKey = (favoriteKind, itemId) =>
  `${favoriteKind}:${Number(itemId)}`;

export const parseFavoriteKey = (rawKey) => {
  if (typeof rawKey === 'number' && Number.isFinite(rawKey)) {
    return { kind: FAVORITE_KIND.ITEM, id: rawKey };
  }
  const key = String(rawKey || '');
  if (!key) return { kind: FAVORITE_KIND.ITEM, id: null };

  const [kind, idPart] = key.split(':');
  if (
    (kind === FAVORITE_KIND.ITEM ||
      kind === FAVORITE_KIND.DESIGNER ||
      kind === FAVORITE_KIND.BOUTIQUE) &&
    idPart
  ) {
    const id = Number(idPart);
    return Number.isFinite(id) ? { kind, id } : { kind: FAVORITE_KIND.ITEM, id: null };
  }

  if (/^\d+$/.test(key)) {
    return { kind: FAVORITE_KIND.ITEM, id: Number(key) };
  }
  return { kind: FAVORITE_KIND.ITEM, id: null };
};

export const normalizeFavoriteKey = (rawKey) => {
  const parsed = parseFavoriteKey(rawKey);
  if (!parsed.id) return null;
  return buildFavoriteKey(parsed.kind, parsed.id);
};

export const migrateFavoriteKeys = (favorites = []) => {
  const seen = new Set();
  const migrated = [];
  favorites.forEach((entry) => {
    const key = normalizeFavoriteKey(entry);
    if (key && !seen.has(key)) {
      seen.add(key);
      migrated.push(key);
    }
  });
  return migrated;
};

export const isFavoriteKey = (favoriteItems, favoriteKind, itemId) => {
  const key = buildFavoriteKey(favoriteKind, itemId);
  return (favoriteItems || []).some(
    (entry) => normalizeFavoriteKey(entry) === key,
  );
};

export const groupFavoriteKeys = (favoriteItems = []) => {
  const grouped = {
    [FAVORITE_KIND.ITEM]: [],
    [FAVORITE_KIND.DESIGNER]: [],
    [FAVORITE_KIND.BOUTIQUE]: [],
  };
  favoriteItems.forEach((entry) => {
    const parsed = parseFavoriteKey(entry);
    if (parsed.id) grouped[parsed.kind].push(parsed.id);
  });
  return grouped;
};

export const getFavoriteTargetFromFeaturedRow = (row) => {
  const catalog = row?.catalog_item;
  if (catalog?.shop_type === 'artist' || row?.artist_item) {
    return { favoriteKind: FAVORITE_KIND.ARTIST, item: catalog || row.artist_item };
  }
  if (catalog?.shop_type === 'boutique' || row?.boutique_item) {
    return { favoriteKind: FAVORITE_KIND.BOUTIQUE, item: catalog || row.boutique_item };
  }
  if (catalog || row?.designer_item) {
    return { favoriteKind: FAVORITE_KIND.DESIGNER, item: catalog || row.designer_item };
  }
  if (row?.item) {
    return { favoriteKind: FAVORITE_KIND.ITEM, item: row.item };
  }
  return null;
};
